"use client";

import { Ref, forwardRef, useEffect, useMemo, useRef, useState } from "react";
import NextImage, { type ImageProps } from "next/image";

const getPlaceholderImage = () => `
	<svg
		width="232"
		height="232"
		viewBox="0 0 232 232"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="232" height="232" rx="8" fill="#F5F5F5" />
		<path
			opacity="0.4"
			d="M141.83 128.424L133.761 109.555C132.292 106.101 130.101 104.141 127.6 104.013C125.126 103.884 122.728 105.611 120.898 108.91L116 117.701C114.969 119.557 113.5 120.665 111.902 120.794C110.278 120.949 108.654 120.098 107.339 118.422L106.772 117.701C104.942 115.406 102.673 114.298 100.353 114.53C98.0332 114.762 96.0483 116.36 94.7336 118.964L90.2741 127.857C88.6758 131.079 88.8305 134.817 90.7123 137.859C92.5941 140.901 95.8678 142.731 99.451 142.731H132.343C135.798 142.731 139.02 141.004 140.927 138.117C142.887 135.229 143.196 131.595 141.83 128.424Z"
			fill="#AEAEAE"
		/>
		<path
			d="M103.034 106.668C107.846 106.668 111.747 102.767 111.747 97.9551C111.747 93.1431 107.846 89.2422 103.034 89.2422C98.2222 89.2422 94.3213 93.1431 94.3213 97.9551C94.3213 102.767 98.2222 106.668 103.034 106.668Z"
			fill="#AEAEAE"
		/>
	</svg>
`;

const toBase64 = (str: string) =>
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);

type ClippedImageProps = ImageProps & {
  src?: string;
  width: number;
  height: number;
  sourceWidth?: number;
  sourceHeight?: number;
  alt: string;
};

export const ClippedImage = forwardRef<HTMLImageElement, ClippedImageProps>(
  (
    {
      src: srcProp,
      width = 100,
      height = 100,
      sourceWidth,
      sourceHeight,
      alt,
      ...rest
    },
    ref
  ) => {
    const [src, setSrc] = useState<string>(srcProp);
    const [loaded, setLoaded] = useState(false);

    if (!src) setSrc("/images/image-placeholder.svg");

    return (
      <>
        {/* {clippedURL === '/images/image-placeholder.svg' && src && (
					<NextImage
						ref={image}
						src={src}
						crossOrigin="anonymous"
						className="absolute opacity-0"
						width={sourceWidth || width}
						height={sourceHeight || height}
						alt={alt}
					/>
				)} */}
        <NextImage
          ref={ref}
          src={src}
          width={width}
          height={height}
          // style={{
          // 	opacity:
          // 		clippedURL === '/images/image-placeholder.svg' && src ? 0 : 1,
          // }}
          className={loaded ? "" : "animate-fadeInFaster"}
          alt={alt}
          onLoad={() => setLoaded(true)}
          placeholder={`data:image/svg+xml;base64,${toBase64(
            getPlaceholderImage()
          )}`}
          onError={() => setSrc("/images/image-placeholder.svg")}
          {...rest}
        />
      </>
    );
  }
);

ClippedImage.displayName = "ClippedImage";
